<template>
  <Starfield>
    <iRow vertical-align="middle" align="center">
      <iColumn
        align="center"
        width="fill"
        :max-width="800"
        :style-overrides="{paddingLeft: 'standard', paddingRight: 'standard'}"
      >
        <iSpace :height="40" />
        <svg width="150" height="150">
          <image :xlink:href="logoUrl" :src="logoUrl" width="150" />
        </svg>
        <iHeading
          :font-size="isMobile ? 'displaySmall' : 'displayLarge'"
          variant="accent"
          :style-overrides="{marginBottom: 'none'}"
        >
          Q3-PO
        </iHeading>
        <iHeading
          :font-size="isMobile ? 'small' : 'default'"
          :wrap="true"
          variant="accent"
        >
          query 3 - projects organize
        </iHeading>
        <template v-if="mfaStep === stepNone">
          <iTextInput
            v-model="email"
            placeholder="Email"
            width="fill"
            @enter="submitLogin"
          />
          <iTextInput
            v-model="password"
            placeholder="Password"
            type="password"
            width="fill"
            @enter="submitLogin"
          />
          <iText v-if="loginErrorMessage" variant="error">
            {{ loginErrorMessage }}
          </iText>
          <iRow width="hug" align="center">
            <iButton
              variant="secondary"
              :is-loading="loadingLogin"
              loading-spinner-position="inside"
              @click="submitLogin"
            >
              Login
            </iButton>
          </iRow>
        </template>
        <template v-else-if="mfaStep === stepBackupCodes">
          <iText :wrap="true">
            Save these backup codes somewhere safe. Each one signs you in once if you lose your authenticator.
          </iText>
          <iColumn data-test="login-backup-codes" align="center" gap="extraSmall">
            <iText v-for="backupCode in backupCodes" :key="backupCode">
              {{ backupCode }}
            </iText>
          </iColumn>
          <iRow width="hug" align="center">
            <iButton variant="secondary" data-test="login-backup-continue" @click="finishLogin">
              Continue
            </iButton>
          </iRow>
        </template>
        <template v-else>
          <template v-if="mfaStep === stepEnroll">
            <iText :wrap="true">
              Your account needs two-factor authentication. Scan this code with an authenticator app,
              or enter the secret below, then type the 6-digit code it shows.
            </iText>
            <iImageContainer
              v-if="totpQrDataUri"
              :src="totpQrDataUri"
              :height="200"
              alt="Authenticator QR code"
            />
            <iText data-test="login-totp-secret" :wrap="true">
              {{ totpSecret }}
            </iText>
          </template>
          <iText v-else :wrap="true">
            Enter the 6-digit code from your authenticator app, or one of your backup codes.
          </iText>
          <iTextInput
            v-model="mfaCode"
            data-test="login-mfa-code"
            placeholder="Authentication code"
            width="fill"
            @enter="submitCode"
          />
          <iText v-if="mfaErrorMessage" variant="error" data-test="login-mfa-error">
            {{ mfaErrorMessage }}
          </iText>
          <iRow width="hug" align="center">
            <iButton
              variant="secondary"
              data-test="login-mfa-verify"
              :is-loading="loadingLogin"
              loading-spinner-position="inside"
              @click="submitCode"
            >
              Verify
            </iButton>
          </iRow>
        </template>
      </iColumn>
    </iRow>
  </Starfield>
</template>

<script>

import { mapActions, mapState } from "pinia";
import {
  useGeneralStore,
  MFA_STEP_NONE,
  MFA_STEP_ENROLL,
  MFA_STEP_BACKUP_CODES,
} from "@/stores/general-store";
import { useWindowStore } from "@bloglovin/vue-component-library";
import Starfield from "@/components/Starfield";
// import SithLogo from "@/icons/logo-sith.svg";

export default {
  name: "Login",
  components: { Starfield },
  data() {
    return {
      email: "",
      password: "",
      mfaCode: "",
      stepNone: MFA_STEP_NONE,
      stepEnroll: MFA_STEP_ENROLL,
      stepBackupCodes: MFA_STEP_BACKUP_CODES,
    };
  },
  computed: {
    ...mapState(useGeneralStore, [
      "loginErrorMessage",
      "loadingLogin",
      "darkSide",
      "mfaStep",
      "mfaErrorMessage",
      "totpSecret",
      "totpQrDataUri",
      "backupCodes",
    ]),
    ...mapState(useWindowStore, ["windowWidth"]),
    isMobile() {
      return this.windowWidth < 624;
    },
    logoUrl() {
      if (this.darkSide) {
        return "logo-sith.svg";
      }
      return "logo-new-republic.svg";
    },
  },
  methods: {
    ...mapActions(useGeneralStore, [
      "login",
      "submitMfaCode",
      "finishLogin",
    ]),
    submitLogin() {
      if (!this.email || !this.password) {
        return;
      }
      this.login(this.email, this.password);
    },
    submitCode() {
      const code = this.mfaCode.trim();
      if (!code) {
        return;
      }
      this.mfaCode = "";
      this.submitMfaCode(code);
    },
  },
};
</script>
